import { List } from "immutable";

export default {
  SET_PLOTS(state, plots) {
    state.plots = plots;
  },
  SET_PAGING(state, data) {
    state.pageable = data;
  },
  SET_FEATURES(state, features) {
    state.features = List(features);
  },
  RESET_STATE(state, data) {
    Object.assign(state, data);
  }
}
